import { WeddingLogo } from "./WeddingLogo";

interface LogoProps {
  size?: number;
  /** Wordmark size; defaults to 4px below `size`. */
  textSize?: number;
}

export function Logo({ size = 28, textSize = size - 4 }: LogoProps) {
  return (
    <span className="sidebar-brand" style={{ padding: 0 }}>
      <span className="sidebar-brand-mark" style={{ width: size + 8, height: size + 8 }}>
        <WeddingLogo size={size - 2} />
      </span>
      <span className="sidebar-brand-name" style={{ fontSize: textSize }}>
        amazing.wedding
      </span>
    </span>
  );
}
